import React from 'react';
import get from 'lodash/get';
import { FormikProps } from 'formik';
import { withInject } from '@piwikpro/platform';
import {
  AutoSavedTextFieldControl,
  Stack,
  withTranslation,
} from '@piwikpro/ui-components';
import { FormValidator } from '@piwikpro/form-crate';
import { TrackerSettings, TrackerSettingsAttributes, TrackerSettingsResponse } from '../../../TrackerSettings';
import FailMessage from '../../GlobalAppSettings/FailMessage';

const defaultValue = 5000;

export interface MaxSessionEventCountProps {
  settings: TrackerSettingsResponse
  trackerSettings: TrackerSettings
  validation: FormValidator
  failed: boolean
  t: (key: string) => string
}

export class MaxSessionEventCount extends React.Component<MaxSessionEventCountProps> {
  static readonly fieldName = 'session_max_event_count';

  constructor(props: MaxSessionEventCountProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: Partial<TrackerSettingsAttributes>, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: FormikProps<TrackerSettingsAttributes>) {
    const { trackerSettings, settings } = this.props;

    try {
      await trackerSettings.updateSettings(values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        MaxSessionEventCount.fieldName,
        settings.attributes[MaxSessionEventCount.fieldName],
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const {
      settings,
      failed,
      validation,
      t,
    } = this.props;

    return (
      <>
        <Stack vertical>
          {!failed && (
            <Stack.Item fill>
              <AutoSavedTextFieldControl
                id="global-settings-max-session-event-count"
                label={t('apps.details.settings.session-limits.max-session-event-count.title')}
                info={t('apps.details.settings.session-limits.max-session-event-count.description')}
                name={MaxSessionEventCount.fieldName}
                initialValue={get(
                  settings.attributes, MaxSessionEventCount.fieldName, defaultValue,
                )}
                type="number"
                validationSchema={validation.createValidationSchema(validators => ({
                  [MaxSessionEventCount.fieldName]: validators.trackerSettings.sessionMaxEventCount,
                }))}
                onSubmit={this.handleSubmit}
              />
            </Stack.Item>
          )}
        </Stack>
        {failed && <FailMessage />}
      </>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  validation: 'FormCrate.validation',
})(withTranslation(['administration'])(MaxSessionEventCount as any));
